<template>
  <div :style="style" class="control-container" @click="demoOnly()">
    <div class="control-row title">
        <CktextComponent :rawHtml="control.data.data.title">    
        </CktextComponent>
        <div v-if="control.data.data.misc.required" class="required">*</div>
    </div>
    <div class="control-row">
        <CktextComponent :rawHtml="control.data.data.subtitle">    
        </CktextComponent>
    </div>
    <div class="control-row">
      <div class="signature-container">
            <div>
                <span class="iconfont icon-m-qianming" style="font-size:2rem"></span>
            </div>    
            <div class="sig-label">{{$t('message.click_sign')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import CktextComponent from '../CkText.vue';

export default {
  name: 'SignatureControl',
  components: {
    CktextComponent
  },
  data(){
    return {
      style:''
    }
  },
  props: {
    control: null
  },
  methods:{
    demoOnly(){

      const msg=this.$t('message.form_unavailable_h5');

      this.$toast.add({severity:'error', summary: this.$common.TITLE, detail:msg, life: 3000});

    }
  },
  created(){
    
    this.style=this.$common.generateStyle(this.control.data.style);

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.control-container:last-child{
      margin-bottom: 0px;
  }
  .control-row{
      margin-bottom: 10px;
      text-align:left;
  }

  .title{
      display: flex;
  }
  .required{
    color:#f7363f;
  }   

  .signature-container{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 120px;
    background: #f3f4f5;
    border-radius: 4px;
    text-align: center;
    width: 100%;
  }

  .sig-label{
    margin-top: 5px;
    font-size: 14px;
    font-weight: 400;
    color: #666;
  }
</style>